var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-sidebar-arrow-up"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sidebar-arrow-up",
    clipPath: "url(#clip-sidebar-arrow-up)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15998",
    "data-name": "Group 15998",
    transform: "translate(-7355 10627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6448",
    "data-name": "Group 6448"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23944",
    "data-name": "Rectangle 23944",
    width: 30,
    height: 30,
    rx: 4,
    transform: "translate(7355 -10627)",
    fill: "#f6f9fc",
    opacity: 0.004
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18430",
    "data-name": "Path 18430",
    d: "M6.481,5.807.807.133A.473.473,0,0,0,.138.8l5.34,5.34-5.34,5.34a.473.473,0,0,0,.669.669L6.481,6.476A.473.473,0,0,0,6.481,5.807Z",
    transform: "translate(7363.659 -10608.741) rotate(-90)",
    fill: "#2f394e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarArrowUp);
export default __webpack_public_path__ + "static/media/sidebar-arrow-up.90ee8ad4fa830fe47dfaada087121bda.svg";
export { ForwardRef as ReactComponent };